/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import * as React from 'react';
import { Link } from 'react-router';
import styled from '@emotion/styled';
import { COLOR, FONT_WEIGHT } from '@ordermentum/ui-constants';
import { ButtonWrapper } from './Button.styles';

const Wrapper = styled(Link)`
  text-decoration: none;
`;

const Text = styled('span')<Partial<Props>>`
  align-items: center;
  color: ${p => (p.color === 'orange' ? COLOR.ORANGE : COLOR.GRAY_500)};
  display: flex;
  font-weight: ${FONT_WEIGHT.NORMAL};
  text-decoration: none;
`;
interface Props {
  to?: string;
  target?: string;
  color?: string;
  children: React.ReactNode;
}

/**
 * @deprecated use RouterButton from @ordermentum/ui-shared/components/Button
 */
const LinkButton = ({ to, color = 'gray', children }: Props) => (
  <Wrapper to={to || ''} css={ButtonWrapper()}>
    <Text color={color}>{children}</Text>
  </Wrapper>
);

export default LinkButton;
